import Icon from "@mui/material/Icon/Icon"
import IconButton from "@mui/material/IconButton/IconButton"
import Input from "@mui/material/Input/Input"
import InputAdornment from "@mui/material/InputAdornment/InputAdornment"
import ListItem from "@mui/material/ListItem/ListItem"
import ListItemIcon from "@mui/material/ListItemIcon/ListItemIcon"
import ListItemText from "@mui/material/ListItemText"
import { useRef, useState } from "preact/hooks"
import { v4 as uuid } from "uuid"
import type { Item } from "./EditableList"

export function ItemEntry({
  onSubmit,
}: {
  onSubmit: ((item: Item) => void) | false
}) {
  const [value, setValue] = useState<string>("")
  const input = useRef<HTMLInputElement>(null)

  const handleSubmit = (event: any): void => {
    if (value === "") return

    event.preventDefault()
    onSubmit && onSubmit({ id: uuid(), content: value })
    setValue("")
  }
  return (
    <ListItem onClick={() => input.current?.focus()}>
      <ListItemIcon>
        <Icon children="add" />
      </ListItemIcon>
      <ListItemText>
        <form onSubmit={handleSubmit}>
          <Input
            value={value}
            disabled={!onSubmit}
            // So that the "Done" key of the iOS Safari
            // Form Assistant will also submit a nomination:
            onBlur={handleSubmit}
            fullWidth
            onChange={(event: any) => setValue(event.target.value)}
            placeholder="New Option"
            inputProps={{ ref: input }}
            endAdornment={
              !!value && (
                <InputAdornment position="end">
                  <IconButton edge="end" onClick={() => setValue("")}>
                    <Icon children="clear" />
                  </IconButton>
                </InputAdornment>
              )
            }
          />
        </form>
      </ListItemText>
    </ListItem>
  )
}
